import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Employees.css';
import {CreateButton, CreateSearchBarWithPlaceHolder, ViewMaintenanceHistory} from './../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTable} from './../ManageTable';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RestoreIcon from '@mui/icons-material/Restore';

function EmployementStatus({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Description",
        "Status",
        "",
    ]
    var accessor = [
        "id",
        "description",
        "status",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employmentStatus, setEmploymentStatus] = useState([]);
     // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [dataToFetch, setDataToFetch] = useState("");
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by description");
    
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [description, setDescription] = useState("");
    const [isActive, setIsActive] = useState(false);
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editDescription, setEditDescription] = useState("");
    const [editIsActive, setEditIsActive] = useState("");
    const [oldEditDescription, setOldEditDescription] = useState("");
    const [oldEditIsActive, setOldEditIsActive] = useState("");

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/Employment";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/active` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setEmploymentStatus(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by description")
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholder("Search by description")
                setDataToFetch("/active")
                break;
            case 2:
                setSearchPlaceholder("Search by employment status id")
                setDataToFetch("");
                break;
            default:
                setSearchPlaceholder("Search by description")
                setDataToFetch("");
                break;
        }
        fetchData(dataToFetch);
        
    }, [fetchData, filterDataIndex, dataToFetch]);

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmploymentStatus(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            description: description,
            isActive: isActive
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            setShowAddForm(false); // Hide the add form

            await SetAuditTrail({
                setupArea: "Employment Status", 
                actionTaken: "insert", 
                field: "Add Employment Status", 
                newValue: description, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setIsActive(false);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            description: editDescription,
            isActive: editIsActive
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.description !== oldEditDescription){
                auditInfo.push({
                    setupArea: "Employment Status",
                    actionTaken: "update",
                    field: "Description",
                    newValue: `${data.description}`,
                    oldValue: `${oldEditDescription}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.isActive !== oldEditIsActive){
                auditInfo.push({
                    setupArea: "Employment Status",
                    actionTaken: "update",
                    field: "Is Active?",
                    newValue: `${data.isActive ? "Active" : "InActive"}`,
                    oldValue: `${oldEditIsActive ? "Active" : "InActive"}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditDescription("");
            setEditIsActive("");
            setEditById("");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditDescription(data.description);
        setEditIsActive(data.isActive);
        setOldEditDescription(data.description);
        setOldEditIsActive(data.isActive);
        setShowEditForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    const [showViewHistory, setShowViewHistory] = useState(false);
    const openViewHistory = () => {
        setShowViewHistory(true);
    }
    const closeViewHistory = () => {
        setShowViewHistory(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Employment Status"}</span>
                            </div>
                            <h3>Employment Status</h3>
                        </div>
                        <div className="employeesTab-body">
                            {Filter(setFilterDataIndex)}
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    searchPlaceholder, 
                                                                    SearchIcon)}
                                </div>
                                <div className="body-top-btn row"  style={{justifyContent: "end"}}>
                                        <button className='border border-sky-800 bg-sky-500 hover:bg-sky-600 text-white cursor-pointer flex flex-row items-center'
                                            onClick={openViewHistory}
                                        >
                                            <RestoreIcon/>
                                            HISTORY
                                        </button>
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={employmentStatus}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    description={description}
                    isActive={isActive}
                    setDescription={setDescription}
                    setIsActive={setIsActive}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editDescription={editDescription}
                    editIsActive={editIsActive}
                    setEditDescription={setEditDescription}
                    setEditIsActive={setEditIsActive}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <ViewMaintenanceHistory 
                isOpen={showViewHistory}
                onClose={closeViewHistory}
                apiUrl={`${domain}/api/Employment`}
                mainFetchData={fetchData}
            />
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({
    isOpen, 
    onClose,
    description, 
    isActive, 
    setDescription, 
    setIsActive, 
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setIsActive(false);
        setErrorState(false);
    };

    const handleIsActiveChange = (event) => {
        setIsActive(event.target.checked);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Employment Status</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editDescription, 
    editIsActive, 
    setEditDescription, 
    setEditIsActive, 
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editDescription){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };
    const handleClose = () => {
        onClose();
        setErrorState(false);
    };
    const handleDescriptionChange = (event) => {
        setEditDescription(event.target.value);
    };
    const handleIsActiveChange = (event) => {
        setEditIsActive(event.target.checked);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Employment Status</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={editDescription}
                                onChange={(e) => handleDescriptionChange(e)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editDescription && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={editIsActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "Active":
                setFilterDataIndex(1);
                break;
            case "EmploymentStatusId":
                setFilterDataIndex(2);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="EmploymentStatusId">Employment Status Id</option>
            </select>
        </div>
    );
};

export default EmployementStatus
